/* GENERATED by scripts/gen-data.mjs — chapter "grounding" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_GROUNDING: NodeDef = {
  "id": "grounding",
  "tagKey": "path:grounding.tag",
  "x": 600,
  "y": 40,
  "w": 220,
  "h": 116,
  "titleKey": "path:grounding.title",
  "subKey": "path:grounding.sub",
  "blocks": [
    {
      "id": "grounding.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:grounding.b1.title",
      "bodyKey": "path:grounding.b1.body",
      "flowKey": "path:grounding.b1.flow",
      "read": [
        "hallu"
      ]
    },
    {
      "id": "grounding.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:grounding.b2.title",
      "film": "f-grounding"
    },
    {
      "id": "grounding.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:grounding.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:grounding.b3o.opts.0.n",
            "wKey": "path:grounding.b3o.opts.0.w",
            "uKey": "path:grounding.b3o.opts.0.u",
            "cKey": "path:grounding.b3o.opts.0.c",
            "slug": "lexical-search"
          },
          {
            "nKey": "path:grounding.b3o.opts.1.n",
            "wKey": "path:grounding.b3o.opts.1.w",
            "uKey": "path:grounding.b3o.opts.1.u",
            "cKey": "path:grounding.b3o.opts.1.c",
            "slug": "dense-retrieval"
          },
          {
            "nKey": "path:grounding.b3o.opts.2.n",
            "wKey": "path:grounding.b3o.opts.2.w",
            "uKey": "path:grounding.b3o.opts.2.u",
            "cKey": "path:grounding.b3o.opts.2.c",
            "slug": "hybrid-then-rerank"
          },
          {
            "nKey": "path:grounding.b3o.opts.3.n",
            "wKey": "path:grounding.b3o.opts.3.w",
            "uKey": "path:grounding.b3o.opts.3.u",
            "cKey": "path:grounding.b3o.opts.3.c",
            "slug": "long-context-instead"
          }
        ],
        "ref": "rag"
      }
    },
    {
      "id": "grounding.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:grounding.b3.title",
      "math": {
        "exprKey": "path:grounding.b3.math.expr",
        "readKey": "path:grounding.b3.math.read",
        "useKey": "path:grounding.b3.math.use",
        "ref": "rag"
      }
    },
    {
      "id": "grounding.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:grounding.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:grounding.b4.ex.bins",
        "binCount": 2,
        "items": [
          {
            "tKey": "path:grounding.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:grounding.b4.ex.items.0.why"
          },
          {
            "tKey": "path:grounding.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:grounding.b4.ex.items.1.why"
          },
          {
            "tKey": "path:grounding.b4.ex.items.2.t",
            "bin": 0,
            "whyKey": "path:grounding.b4.ex.items.2.why"
          },
          {
            "tKey": "path:grounding.b4.ex.items.3.t",
            "bin": 1,
            "whyKey": "path:grounding.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
